import { useTheme } from '@mui/material';
import { Heading4, TextM } from 'app/components';
import {
  ReviewSimulationBox,
  ReviewSimulationPreviewItem,
  ReviewSimulationPreviewItems,
  ReviewStepBox,
} from '../styles';
import { ReviewStepSimulationDivider } from './ReviewStepSimulationDivider';
import { ConsignedConfig } from '../utils/borrowerTypeParser';

interface ReviewStepConsignedSiapeProps {
  consignedConfig: ConsignedConfig | null;
}

const ReviewStepConsignedSiape = ({
  consignedConfig,
}: ReviewStepConsignedSiapeProps) => {
  const theme = useTheme();

  return (
    <ReviewStepBox marginTop="0px" marginBottom="16px">
      <Heading4
        style={{
          color: theme.palette.brand.secondary.base,
        }}
      >
        Consignado Siape
      </Heading4>
      <ReviewSimulationBox>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Órgão
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {consignedConfig?.employer?.name || 'Indisponível'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Matrícula do tomador
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {consignedConfig?.employee?.code || '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Classificação
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {consignedConfig?.meta_data?.classification_description ||
                  'Não informado'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Código do órgão
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {consignedConfig?.employer?.code || 'Indisponível'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Tipo de vínculo
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {consignedConfig?.meta_data?.functional_status_description ||
                  '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Nome do produto
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                Empréstimo Siape
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
      </ReviewSimulationBox>
    </ReviewStepBox>
  );
};

export default ReviewStepConsignedSiape;
